import axios from 'axios';
import { Story } from '../types/StoryTypes';

const API_BASE_URL = 'http://192.168.0.249:8000'; // Change to your actual backend URL

/**
 * Analyzes a single story using NLP services
 * @param story The story to analyze
 * @returns Analysis results from the NLP service
 */
const analyzeStory = async (story: Story) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/gather-data`, {
      method: 'text',
      options: {
        content: story.text,
        parameters: {
          graphType: 'directed',
          entityFilters: [
            'TREATMENT', 'MEDICATION', 'SYMPTOM', 'CONDITION', 
            'PROCEDURE', 'PERSON', 'ORG', 'GPE', 'DATE', 
            'WORK_OF_ART', 'PRODUCT'
          ],
          // You might also want to add domain-specific context
          domainContext: "medical"
        }
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error analyzing story:', error);
    throw error;
  }
};

/**
 * Analyzes multiple stories in a batch
 * @param stories Array of stories to analyze
 * @returns Combined analysis results
 */
const analyzeBatch = async (stories: Story[]) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/batch-analyze`, {
      stories: stories.map(s => ({ 
        id: s.id,
        text: s.text,
        xLink: s.xLink
      }))
    });
    
    return response.data;
  } catch (error) {
    console.error('Error analyzing story batch:', error);
    throw error;
  }
};

// Export the service functions as a default object
const nlpService = {
  analyzeStory,
  analyzeBatch
};

export default nlpService;